import styled, { css } from 'styled-components';
import MuiTableCell from '@mui/material/TableCell';
import { hexToRgba } from 'src/utils/helpers';

interface TableCellProps {
  /** is it a table title or not */
  $isTitle?: boolean;
  $size?: number;
  $isExpanded?: boolean;
}
export const TableCell = styled(MuiTableCell)<TableCellProps>`
  &.MuiTableCell-root {
    padding: 8px 8px;
    border-color: ${({ theme }) => theme.colors.borderColor};
    color: ${({ theme }) => theme.colors.textColor};

    ${({ $isTitle }) =>
      $isTitle &&
      css`
        font-weight: 600;
        font-size: 1rem;
        text-transform: capitalize;
      `};

    ${({ $size }) =>
      $size &&
      css`
        width: ${$size}px;
      `};

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        background-color: ${({ theme }) => hexToRgba(theme.colors.primary, 0.2)} !important;
      `};
  }
`;
